var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 88,
    viewBox: "0 0 85 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_123:4309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7959 53.3755C59.3189 53.3755 59.7428 52.9515 59.7428 52.4286C59.7428 51.9056 59.3189 51.4816 58.7959 51.4816C58.2729 51.4816 57.849 51.9056 57.849 52.4286C57.849 52.9515 58.2729 53.3755 58.7959 53.3755ZM58.7959 54.7959C60.1034 54.7959 61.1633 53.736 61.1633 52.4286C61.1633 51.1211 60.1034 50.0612 58.7959 50.0612C57.4885 50.0612 56.4286 51.1211 56.4286 52.4286C56.4286 53.736 57.4885 54.7959 58.7959 54.7959Z",
    fill: "#F5DF4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8643 37.7422V40.6697L25.3352 43.6718V46.9325C24.3125 47.2537 23.5706 48.2091 23.5706 49.3379C23.5706 50.73 24.6992 51.8586 26.0914 51.8586C27.4836 51.8586 28.6122 50.73 28.6122 49.3379C28.6122 48.2091 27.8704 47.2537 26.8477 46.9325V44.3708L30.3768 41.3688V37.7422H28.8643ZM27.0997 49.3379C27.0997 49.8947 26.6483 50.3462 26.0914 50.3462C25.5346 50.3462 25.0831 49.8947 25.0831 49.3379C25.0831 48.781 25.5346 48.3295 26.0914 48.3295C26.6483 48.3295 27.0997 48.781 27.0997 49.3379Z",
    fill: "#F5DF4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7952 42.2797L50.7952 43.7921L49.2827 43.7921L49.2827 42.2797L50.7952 42.2797Z",
    fill: "#F5DF4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7952 37.7422L50.7952 41.2713L49.2827 41.2713L49.2827 37.7422L50.7952 37.7422Z",
    fill: "#F5DF4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1413 56.396C32.6982 56.396 33.1496 55.9446 33.1496 55.3877C33.1496 54.8309 32.6982 54.3794 32.1413 54.3794C31.5844 54.3794 31.133 54.8309 31.133 55.3877C31.133 55.9446 31.5844 56.396 32.1413 56.396ZM32.1413 57.9085C33.5335 57.9085 34.6621 56.7799 34.6621 55.3877C34.6621 53.9955 33.5335 52.8669 32.1413 52.8669C30.7491 52.8669 29.6205 53.9955 29.6205 55.3877C29.6205 56.7799 30.7491 57.9085 32.1413 57.9085Z",
    fill: "#F5DF4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.519 49.6841V38.2245H41.0408V50.2542L39.0117 52.5032V60.7143H37.4898V51.9331L39.519 49.6841Z",
    fill: "#F5DF4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6006 43.713V38.2245H35.1225V44.2858L33.0933 46.5455V54.2041L31.5714 53.6122V45.9727L33.6006 43.713Z",
    fill: "#F5DF4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5015 37.7422H43.989V47.5816L46.0056 50.2733V59.5364C44.9829 59.8576 44.2411 60.8131 44.2411 61.9418C44.2411 63.334 45.3697 64.4626 46.7619 64.4626C48.1541 64.4626 49.2827 63.334 49.2827 61.9418C49.2827 60.8131 48.5408 59.8576 47.5181 59.5364V49.7696L45.5015 47.0779V37.7422ZM47.7702 61.9418C47.7702 62.4987 47.3187 62.9501 46.7619 62.9501C46.205 62.9501 45.7536 62.4987 45.7536 61.9418C45.7536 61.3849 46.205 60.9335 46.7619 60.9335C47.3187 60.9335 47.7702 61.3849 47.7702 61.9418Z",
    fill: "#F5DF4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0612 38.2245H55.5831V40.9713L57.6122 42.2517V44.1429H56.0904V42.961L54.0612 41.6806V38.2245Z",
    fill: "#F5DF4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4514 11V12.5297L34.9136 12.5297V11H33.4514ZM37.3505 11V17.1187H38.8127V11H37.3505ZM25.6843 29.9388C26.026 24.7739 29.1414 20.4258 33.4514 18.5791V13.5495H34.9136V18.0631V19.6559V19.6681H34.8758C30.3962 21.1316 27.1152 25.5824 27.1152 30.8857C27.1152 32.2128 27.3207 33.4866 27.699 34.6735H26.4379C26.3479 34.6735 26.2584 34.6756 26.1695 34.6798C25.8437 33.5141 25.6641 32.2812 25.6536 31.0051C25.6532 31.0442 25.6531 31.0833 25.6531 31.1224C25.6531 31.2561 25.655 31.3893 25.6588 31.5219H18.0688C17.2214 31.5219 16.5344 32.2307 16.5344 33.1051C16.5344 33.9795 17.2214 34.6883 18.0688 34.6883H26.0288C24.6701 34.787 23.4481 35.3733 22.5399 36.2714H18.0688C17.4871 36.2714 16.9431 36.1044 16.4796 35.8143L16.4796 62.8843C16.4796 65.4175 18.4669 67.4711 20.9184 67.4711V69C17.6497 69 15 66.2619 15 62.8843V33.1051V32.898C15 32.9314 15.0006 32.9648 15.0017 32.998C15.0564 31.2989 16.4087 29.9388 18.0688 29.9388H25.6843ZM15 32.898V32.3061H15.0614C15.0211 32.4973 15 32.6953 15 32.898ZM49.9955 34.6735H48.4643C48.8426 33.4866 49.048 32.2128 49.048 30.8857C49.048 25.5824 45.767 21.1316 41.2874 19.6681H41.2497V19.6559V18.0631V16.0989H42.7119V18.5791C47.0218 20.4258 50.1373 24.7739 50.479 29.9388H56.4286V34.6735H54.8942V31.5219H50.5045C50.5083 31.3893 50.5102 31.2561 50.5102 31.1224C50.5102 31.0833 50.51 31.0442 50.5097 31.0051C50.4992 32.2788 50.3202 33.5096 49.9955 34.6735ZM41.2497 15.0791V13.5495H42.7119V15.0791H41.2497Z",
    fill: "#F5DF4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1829 24.4829H38.1912V22.6176H39.7036V24.5052C40.5266 24.5861 41.2244 24.8872 41.7969 25.4086C42.4866 26.0257 42.8314 26.8 42.8314 27.7317C42.8314 28.7723 42.3958 29.6193 41.5247 30.2727C42.1055 30.5631 42.5592 30.9745 42.8859 31.5069C43.2247 32.0393 43.3941 32.6261 43.3941 33.2674C43.3941 33.7944 43.2891 34.2777 43.0792 34.7173H40.7047C40.7953 34.6544 40.8811 34.5825 40.962 34.5016C41.3371 34.1386 41.5247 33.6848 41.5247 33.1403C41.5247 32.5958 41.3371 32.1421 40.962 31.7791C40.599 31.4161 40.1392 31.2346 39.5826 31.2346H35.2086V34.7173H33.3936V24.4829H35.6704V22.6176H37.1829L37.1829 24.4829ZM33.3936 36.734V36.734H39.5826C39.5862 36.734 39.5898 36.734 39.5933 36.734H33.3936ZM35.2086 26.1709H39.2378C39.7339 26.1709 40.1453 26.3342 40.472 26.6609C40.7987 26.9755 40.962 27.3748 40.962 27.8588C40.962 28.3428 40.7987 28.7481 40.472 29.0748C40.1453 29.3894 39.7339 29.5467 39.2378 29.5467H35.2086V26.1709Z",
    fill: "#F5DF4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5621 36.1659H26.4379C24.2209 36.1659 22.4237 37.9478 22.4237 40.1458V67.5075H65.5763V58.3469H58.4826C55.387 58.3469 52.8776 55.6972 52.8776 52.4286C52.8776 49.1599 55.387 46.5102 58.4826 46.5102H65.5763V40.1458C65.5763 37.9478 63.7791 36.1659 61.5621 36.1659ZM67.0816 46.5102V40.1458C67.0816 37.1235 64.6105 34.6735 61.5621 34.6735H26.4379C23.3895 34.6735 20.9184 37.1235 20.9184 40.1458V69H67.0816V58.3469H69.449V46.5102H67.0816ZM58.4826 48.0541H67.9868V56.803H58.4826C56.1946 56.803 54.3397 54.8445 54.3397 52.4286C54.3397 50.0126 56.1946 48.0541 58.4826 48.0541Z",
    fill: "#F5DF4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_123:4309",
    x: 0,
    y: 0,
    width: 84.449,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870833 0 0 0 0 0.731472 0 0 0 0 0.14151 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_123:4309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_123:4309",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurse);
export default __webpack_public_path__ + "static/media/purse.1da141a8.svg";
export { ForwardRef as ReactComponent };